import { Checkbox } from 'antd';
import { createPortal } from 'react-dom';
import css from './index.module.scss';
import Light from './icons/Light';
import WiFi from './icons/WiFi';
import TV from './icons/TV';
import Laptop from './icons/Laptop';
import WaterHeater from './icons/WaterHeater';
import Washer from './icons/Washer';
import Oven from './icons/Oven';
import Refrigerator from './icons/Refrigerator';
import Microwave from './icons/Microwave';
import Cooktop from './icons/Cooktop';
import Kettle from './icons/Kettle';
import CoffeeMaker from './icons/CoffeeMaker';
import AC from './icons/AC';
import Dryer from './icons/Dryer';
import WaterPump from './icons/WaterPump';
import Customize from './icons/Customize';
import Question from './icons/Question';
import QuestionHover from './icons/QuestionHover';
import Add from './icons/Add';
import SumpPump from './icons/SumpPump';
import QuestionModal from './QuestionModal';
import CustomizeModal from './CustomizeModal';
import { useGlobal } from '@/utils/useGlobal';

export default function Step2A({ calcObj, callback }) {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');
    const [question, setQuestion] = useState(null);
    const [customize, setCustomize] = useState(null);
    const [isClient, setIsClient] = useState(false);

    const iconMap = {
        Light: <Light />,
        WiFi: <WiFi />,
        TV: <TV />,
        Laptop: <Laptop />,
        WaterHeater: <WaterHeater />,
        Washer: <Washer />,
        Oven: <Oven />,
        Refrigerator: <Refrigerator />,
        Microwave: <Microwave />,
        Cooktop: <Cooktop />,
        Kettle: <Kettle />,
        CoffeeMaker: <CoffeeMaker />,
        AC: <AC />,
        Dryer: <Dryer />,
        WaterPump: <WaterPump />,
        Customize: <Customize />,
        SumpPump: <SumpPump />,
    };

    const allApps = [
        {
            title: t('step2_A_sub1_title'),
            apps: [
                {
                    icon: 'Light',
                    title: t('step2_A_sub1_app1_title'),
                    desc: t('step2_A_sub1_app1_desc'),
                    text: t('step2_A_sub1_app1_text'),
                    power: 160,
                    watt: 10,
                    key: 'light',
                },
                {
                    icon: 'WiFi',
                    title: t('step2_A_sub1_app2_title'),
                    desc: t('step2_A_sub1_app2_desc'),
                    text: t('step2_A_sub1_app2_text'),
                    power: 240,
                    watt: 10,
                    key: 'wifi',
                },
                {
                    icon: 'TV',
                    title: t('step2_A_sub1_app3_title'),
                    desc: t('step2_A_sub1_app3_desc'),
                    text: t('step2_A_sub1_app3_text'),
                    power: 600,
                    watt: 100,
                    key: 'tv',
                },
                {
                    icon: 'Laptop',
                    title: t('step2_A_sub1_app4_title'),
                    desc: t('step2_A_sub1_app4_desc'),
                    text: t('step2_A_sub1_app4_text'),
                    power: 720,
                    watt: 120,
                    key: 'laptop',
                },
                {
                    icon: 'WaterHeater',
                    title: t('step2_A_sub1_app5_title'),
                    desc: t('step2_A_sub1_app5_desc'),
                    text: t('step2_A_sub1_app5_text'),
                    power: 900,
                    watt: 1800,
                    key: 'water_heater',
                },
                {
                    icon: 'Washer',
                    title: t('step2_A_sub1_app6_title'),
                    desc: t('step2_A_sub1_app6_desc'),
                    text: t('step2_A_sub1_app6_text'),
                    power: 500,
                    watt: 500,
                    key: 'washer',
                },
            ],
        },
        {
            title: t('step2_A_sub2_title'),
            apps: [
                {
                    icon: 'Oven',
                    title: t('step2_A_sub2_app1_title'),
                    desc: t('step2_A_sub2_app1_desc'),
                    text: t('step2_A_sub2_app1_text'),
                    power: 2475,
                    watt: 1650,
                    key: 'oven',
                },
                {
                    icon: 'Refrigerator',
                    title: t('step2_A_sub2_app2_title'),
                    desc: t('step2_A_sub2_app2_desc'),
                    text: t('step2_A_sub2_app2_text'),
                    power: 4800,
                    watt: 200,
                    key: 'refrigerator',
                },
                {
                    icon: 'Microwave',
                    title: t('step2_A_sub2_app3_title'),
                    desc: t('step2_A_sub2_app3_desc'),
                    text: t('step2_A_sub2_app3_text'),
                    power: 700,
                    watt: 1400,
                    key: 'microwave',
                },
                {
                    icon: 'Cooktop',
                    title: t('step2_A_sub2_app4_title'),
                    desc: t('step2_A_sub2_app4_desc'),
                    text: t('step2_A_sub2_app4_text'),
                    power: 2700,
                    watt: 1800,
                    key: 'cooktop',
                },
                {
                    icon: 'Kettle',
                    title: t('step2_A_sub2_app5_title'),
                    desc: t('step2_A_sub2_app5_desc'),
                    text: t('step2_A_sub2_app5_text'),
                    power: 375,
                    watt: 1500,
                    key: 'kettle',
                },
                {
                    icon: 'CoffeeMaker',
                    title: t('step2_A_sub2_app6_title'),
                    desc: t('step2_A_sub2_app6_desc'),
                    text: t('step2_A_sub2_app6_text'),
                    power: 250,
                    watt: 1000,
                    key: 'coffee_maker',
                },
            ],
        },
        {
            title: t('step2_A_sub3_title'),
            apps: [
                {
                    icon: 'AC',
                    title: t('step2_A_sub3_app1_title'),
                    desc: t('step2_A_sub3_app1_desc'),
                    text: t('step2_A_sub3_app1_text'),
                    power: 5250,
                    watt: 1050,
                    key: 'ac_90A',
                },
                {
                    icon: 'AC',
                    title: t('step2_A_sub3_app2_title'),
                    desc: t('step2_A_sub3_app2_desc'),
                    text: t('step2_A_sub3_app2_text'),
                    power: 7000,
                    watt: 1400,
                    key: 'ac_120A',
                },
                {
                    icon: 'AC',
                    title: t('step2_A_sub3_app3_title'),
                    desc: t('step2_A_sub3_app3_desc'),
                    text: t('step2_A_sub3_app3_text'),
                    power: 8750,
                    watt: 1750,
                    key: 'ac_150A',
                },
                {
                    icon: 'Dryer',
                    title: t('step2_A_sub3_app4_title'),
                    desc: t('step2_A_sub3_app4_desc'),
                    text: t('step2_A_sub3_app4_text'),
                    power: 3000,
                    watt: 3000,
                    key: 'dryer',
                },
                {
                    icon: 'WaterPump',
                    title: t('step2_A_sub3_app5_title'),
                    desc: t('step2_A_sub3_app5_desc'),
                    text: t('step2_A_sub3_app5_text'),
                    power: 3000,
                    watt: 1000,
                    key: 'water_pump',
                },
            ],
        },
        {
            title: t('step2_A_sub4_title'),
            apps: [
                {
                    icon: 'Customize',
                    title: t('step2_A_sub4_app1_title'),
                    desc: t('step2_A_sub4_app1_desc'),
                    power: 0,
                    watt: 0,
                    key: 'customize',
                },
            ],
        },
    ];
    if (locale === 'ca') {
        allApps[2].apps.push({
            icon: 'SumpPump',
            title: t('step2_A_sub3_app6_title'),
            desc: t('step2_A_sub3_app6_desc'),
            text: t('step2_A_sub3_app6_text'),
            power: 250,
            watt: 250,
            key: 'sump_pump',
        });
    }

    const [appArr, setAppArr] = useState(calcObj?.apps?.length > 0 ? calcObj?.apps : allApps);

    const calculateTotalPower = (selectedArr: any) => {
        let power = 0,
            watt = 0,
            selectedText = '';
        appArr?.map((group: any) => {
            group?.apps?.map((app: any) => {
                if (selectedArr.find((item: any) => item === app.key)) {
                    power += app?.power || 0;
                    watt += app?.watt || 0;
                    if (!app.key.startsWith('customize')) {
                        selectedText += `${selectedText ? ', ' : ''}${app.title}`;
                    }
                }
            });
        });
        return {
            totalPower: power,
            totalWatt: watt,
            selectedText,
        };
    };

    const [selected, setSelected] = useState(calcObj?.selected || []);

    const handleChangeCheck = (app: any, e: any) => {
        const apps = [];
        appArr?.map((group: any) => {
            apps?.push(group?.apps);
        });

        if (e.target.checked) {
            const checkedAppliances = [...selected, app.key];
            setSelected(checkedAppliances);
            callback({ ...calcObj, ...calculateTotalPower(checkedAppliances), selected: checkedAppliances, apps: appArr });
        } else {
            const checkedAppliances = selected.filter((item: any) => item !== app.key);
            setSelected(checkedAppliances);

            callback({ ...calcObj, ...calculateTotalPower(checkedAppliances), selected: checkedAppliances, apps: appArr });
        }
    };

    const handleClear = () => {
        setSelected([]);
        setAppArr(allApps);
        callback({ ...calcObj, selected: [], totalPower: 0, apps: [] });
    };

    const handleAdd = (app: any, group: any) => {
        setCustomize({ ...app, key: `customize-${group?.apps?.length}` });
    };

    const handleEdit = (app: any) => {
        setCustomize(app);
    };

    const handleCustomizeBack = (newItem?: any) => {
        setCustomize(null);
        if (newItem) {
            const all = JSON.parse(JSON.stringify(appArr));
            const lastIdx = all.length - 1;
            const { title, apps } = all[lastIdx];
            // const lastAppIdx = apps.length - 1;
            // const lastApp = apps[lastAppIdx];
            // 编辑 or 新增
            const targetApp = apps?.find((app: any) => app?.key === newItem?.key);
            if (targetApp) {
                const targetIndex = apps?.findIndex((app: any) => app?.key === newItem?.key);
                const newApps = [...all?.slice(0, lastIdx), { title, apps: [...apps.slice(0, targetIndex), newItem, ...apps.slice(targetIndex + 1)] }];
                setAppArr(newApps);
                const newTotalPower = calcObj.totalPower + (Number(newItem.power) - Number(targetApp.power));
                const newTotalWatt = calcObj.totalWatt + (Number(newItem.watt) - Number(targetApp.watt));
                callback({ ...calcObj, totalPower: newTotalPower, totalWatt: newTotalWatt, apps: newApps });
            } else {
                setSelected([...calcObj?.selected, newItem.key]);
                // const newApps = [...all?.slice(0, lastIdx), { title, apps: [...apps, newItem] }];
                // kun 要求不是追加而是替换 => 永远只有一个Customize
                const newApps = [...all?.slice(0, lastIdx), { title, apps: [newItem] }];
                setAppArr(newApps);
                const newTotalPower = calcObj.totalPower + Number(newItem.power);
                const newTotalWatt = calcObj.totalWatt + Number(newItem.watt);
                callback({ ...calcObj, selected: [...calcObj?.selected, newItem.key], totalPower: newTotalPower, totalWatt: newTotalWatt, apps: newApps });
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={`dpu-calculator-step2-A ${css['dpu-calculator-step2-A']}`}>
            <p className="title">{t('step2_A_title')}</p>
            <ul className="app-groups">
                {appArr?.map((group: any, k: number) => (
                    <li className="app-group" key={k}>
                        <div className="group-title-box">
                            <p className="group-title">{group.title}</p>
                            {k === 0 && (
                                <span className="clear" onClick={handleClear}>
                                    {t('step2_A_clear')}
                                </span>
                            )}
                        </div>
                        <ul className="app-cards">
                            {group.apps?.map((app: any, m: number) => (
                                <li className={`app-card ${String(app?.key).startsWith('customize-') ? 'customize-app' : ''}`} key={app.key}>
                                    <div className="app-icon">{iconMap[app.icon]}</div>
                                    <div className="app-info">
                                        <div className="app-title-box">
                                            <span className="app-title">{app.title}</span>
                                            {!String(app.key).startsWith('customize') && (
                                                <span className="question" onClick={() => setQuestion(app)}>
                                                    <Question />
                                                    <QuestionHover />
                                                </span>
                                            )}
                                        </div>
                                        <p className="app-desc">{app.desc}</p>
                                    </div>
                                    {String(app?.key).startsWith('customize-') && (
                                        <p className="customize-edit" onClick={() => handleEdit(app)}>
                                            {t('step2_A_edit')}
                                        </p>
                                    )}
                                    {app.key !== 'customize' && (
                                        <div className="check-box">
                                            <Checkbox checked={selected.includes(app.key)} onChange={(e: any) => handleChangeCheck(app, e)} />
                                        </div>
                                    )}
                                    {app.key === 'customize' && (
                                        <div className="add-icon" onClick={() => handleAdd(app, group)}>
                                            <Add />
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
            {question && isClient && createPortal(<QuestionModal app={question} callback={() => setQuestion(null)} />, document.body)}
            {customize && isClient && createPortal(<CustomizeModal app={customize} callback={handleCustomizeBack} />, document.body)}
        </div>
    );
}
